import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import {
  VALUATION_AGENT_REPORTABLE_REASON_VALUES,
  ValuationAgentRequestKindSchema,
} from '../valuation/valuation-agent-request.schemas';

/**
 * Bus events for the valuation agent's inbox (IMM-1402). Ids and enums only: the agent's free-text hint stays on
 * the row, never in an event.
 */
export const ValuationAgentRequestOpenedPayloadSchema = z.object({
  requestId: z.uuid(),
  workspaceId: z.uuid(),
  propertyId: z.uuid(),
  dealId: z.uuid().nullable(),
  kind: ValuationAgentRequestKindSchema,
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type ValuationAgentRequestOpenedPayload = z.infer<typeof ValuationAgentRequestOpenedPayloadSchema>;

export const ValuationAgentRequestTakenPayloadSchema = z.object({
  requestId: z.uuid(),
  workspaceId: z.uuid(),
  agentTokenId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type ValuationAgentRequestTakenPayload = z.infer<typeof ValuationAgentRequestTakenPayloadSchema>;

export const ValuationAgentRequestFailedPayloadSchema = z.object({
  requestId: z.uuid(),
  workspaceId: z.uuid(),
  reason: z.enum(VALUATION_AGENT_REPORTABLE_REASON_VALUES),
  agentTokenId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type ValuationAgentRequestFailedPayload = z.infer<typeof ValuationAgentRequestFailedPayloadSchema>;

export const ValuationAgentRequestDeliveredPayloadSchema = z.object({
  requestId: z.uuid(),
  workspaceId: z.uuid(),
  kind: ValuationAgentRequestKindSchema,
  agentTokenId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type ValuationAgentRequestDeliveredPayload = z.infer<typeof ValuationAgentRequestDeliveredPayloadSchema>;
